function NotFound() {
    return (
    <>
    <h1>404</h1>
    <p>Can't find what you're looking for, sorry!</p>
    </>
);
}
export default NotFound;